export default "<li-ionic4-datepicker [(ngModel)]=\"mydate\" [inputDateConfig]=\"datePickerObj\"></li-ionic4-datepicker>\n"